import React from 'react';
import DatePickers from '@pages-clean/dummy-page/pages/date-picker-page';
import DateTimePickers from '@pages-clean/dummy-page/pages/datetime-picker-page';

const DateInputsPage = () => {
    return (
        <>
            <h2>Date Picker</h2>
            <DatePickers />
            <h2>Date Time Picker</h2>
            <DateTimePickers />
        </>
    );
};

export default DateInputsPage;
